var map = {
	"./1855": 221,
	"./1855.png": 221,
	"./222": 222,
	"./222.png": 222,
	"./about/bg-cta": 223,
	"./about/bg-cta.png": 223,
	"./about/bg-story": 224,
	"./about/bg-story.png": 224,
	"./about/bg-vision": 225,
	"./about/bg-vision.png": 225,
	"./about/main-banner-desktop": 45,
	"./about/main-banner-desktop.png": 45,
	"./about/main-banner-desktop.webp": 891,
	"./about/main-banner-mobile": 46,
	"./about/main-banner-mobile.png": 46,
	"./about/main-banner-mobile.webp": 892,
	"./about/main-banner-tab": 47,
	"./about/main-banner-tab.png": 47,
	"./about/main-banner-tab.webp": 893,
	"./about/person/jon": 48,
	"./about/person/jon.png": 48,
	"./about/person/jon.webp": 894,
	"./about/person/putra": 49,
	"./about/person/putra.png": 49,
	"./about/person/putra.webp": 895,
	"./about/person/ric": 50,
	"./about/person/ric.png": 50,
	"./about/person/ric.webp": 896,
	"./about/person/suren": 51,
	"./about/person/suren.png": 51,
	"./about/person/suren.webp": 897,
	"./about/person/yunita": 52,
	"./about/person/yunita.png": 52,
	"./about/person/yunita.webp": 898,
	"./about/social/blogger": 226,
	"./about/social/blogger.png": 226,
	"./about/social/email": 227,
	"./about/social/email.png": 227,
	"./about/social/facebook": 228,
	"./about/social/facebook.png": 228,
	"./about/social/instagram": 229,
	"./about/social/instagram.png": 229,
	"./about/social/linkedin": 230,
	"./about/social/linkedin.png": 230,
	"./about/social/pinterest": 231,
	"./about/social/pinterest.png": 231,
	"./about/social/youtube": 232,
	"./about/social/youtube.png": 232,
	"./about/world-map": 233,
	"./about/world-map.png": 233,
	"./amara": 234,
	"./amara.png": 234,
	"./arrow-down-icon": 235,
	"./arrow-down-icon.png": 235,
	"./attch": 236,
	"./attch.png": 236,
	"./avatar": 237,
	"./avatar.jpg": 237,
	"./banner/onboarding": 238,
	"./banner/onboarding.png": 238,
	"./banner/supervenue": 239,
	"./banner/supervenue.png": 239,
	"./bg-card": 240,
	"./bg-card.png": 240,
	"./bg-contact": 241,
	"./bg-contact.png": 241,
	"./bg-criteria": 242,
	"./bg-criteria.png": 242,
	"./bg-half": 243,
	"./bg-half.png": 243,
	"./calendar/arrow-right": 244,
	"./calendar/arrow-right.png": 244,
	"./calendar/calendar-check": 245,
	"./calendar/calendar-check.png": 245,
	"./calendar/change": 246,
	"./calendar/change.png": 246,
	"./calendar/google": 247,
	"./calendar/google.png": 247,
	"./calendar/outlook": 248,
	"./calendar/outlook.png": 248,
	"./down-icon": 249,
	"./down-icon.svg": 249,
	"./facebook-icon": 250,
	"./facebook-icon.png": 250,
	"./favicon": 251,
	"./favicon.png": 251,
	"./filter-icon": 252,
	"./filter-icon.png": 252,
	"./frontend_application/Balon": 253,
	"./frontend_application/Balon.svg": 253,
	"./frontend_application/Bannerdesktop": 254,
	"./frontend_application/Bannerdesktop.png": 254,
	"./frontend_application/Bannermobile": 255,
	"./frontend_application/Bannermobile.png": 255,
	"./frontend_application/Bannertablet": 256,
	"./frontend_application/Bannertablet.png": 256,
	"./frontend_application/bank-placeholder": 257,
	"./frontend_application/bank-placeholder.svg": 257,
	"./frontend_application/banner-enquiry-ebook": 258,
	"./frontend_application/banner-enquiry-ebook.png": 258,
	"./frontend_application/banner-home": 53,
	"./frontend_application/banner-home.jpg": 53,
	"./frontend_application/banner-home.webp": 899,
	"./frontend_application/banner-miceneurol": 259,
	"./frontend_application/banner-miceneurol-2": 260,
	"./frontend_application/banner-miceneurol-2.png": 260,
	"./frontend_application/banner-miceneurol.png": 259,
	"./frontend_application/banner-onboard": 261,
	"./frontend_application/banner-onboard.png": 261,
	"./frontend_application/banner-post-enquiry": 262,
	"./frontend_application/banner-post-enquiry.png": 262,
	"./frontend_application/banner-sgbrideonthehunt-ipad": 263,
	"./frontend_application/banner-sgbrideonthehunt-ipad.png": 263,
	"./frontend_application/banner-sgbrideonthehunt-md": 264,
	"./frontend_application/banner-sgbrideonthehunt-md.png": 264,
	"./frontend_application/banner-sgbrideonthehunt-sm": 265,
	"./frontend_application/banner-sgbrideonthehunt-sm.png": 265,
	"./frontend_application/banner-sgbrideonthehunt-tablet": 266,
	"./frontend_application/banner-sgbrideonthehunt-tablet.png": 266,
	"./frontend_application/banner-sgbrideonthehunt2-md": 267,
	"./frontend_application/banner-sgbrideonthehunt2-md.png": 267,
	"./frontend_application/banner-sgbrideonthehunt2-sm": 268,
	"./frontend_application/banner-sgbrideonthehunt2-sm.png": 268,
	"./frontend_application/banner-upgrade": 269,
	"./frontend_application/banner-upgrade.png": 269,
	"./frontend_application/banner/eo-outside-sg/desktop": 270,
	"./frontend_application/banner/eo-outside-sg/desktop.png": 270,
	"./frontend_application/banner/eo-outside-sg/mobile": 271,
	"./frontend_application/banner/eo-outside-sg/mobile.png": 271,
	"./frontend_application/banner/eo-outside-sg/tab": 272,
	"./frontend_application/banner/eo-outside-sg/tab.png": 272,
	"./frontend_application/banner/eo-sg/desktop": 273,
	"./frontend_application/banner/eo-sg/desktop.png": 273,
	"./frontend_application/banner/eo-sg/mobile": 274,
	"./frontend_application/banner/eo-sg/mobile.png": 274,
	"./frontend_application/banner/eo-sg/tab": 275,
	"./frontend_application/banner/eo-sg/tab.png": 275,
	"./frontend_application/banner/free-outside-sg/desktop": 276,
	"./frontend_application/banner/free-outside-sg/desktop.png": 276,
	"./frontend_application/banner/free-outside-sg/mobile": 277,
	"./frontend_application/banner/free-outside-sg/mobile.png": 277,
	"./frontend_application/banner/free-outside-sg/tab": 278,
	"./frontend_application/banner/free-outside-sg/tab.png": 278,
	"./frontend_application/banner/free-sg/desktop": 279,
	"./frontend_application/banner/free-sg/desktop.png": 279,
	"./frontend_application/banner/free-sg/mobile": 280,
	"./frontend_application/banner/free-sg/mobile.png": 280,
	"./frontend_application/banner/free-sg/tab": 281,
	"./frontend_application/banner/free-sg/tab.png": 281,
	"./frontend_application/banner_emerge_venuerific_2022": 282,
	"./frontend_application/banner_emerge_venuerific_2022.png": 282,
	"./frontend_application/banner_get_more": 283,
	"./frontend_application/banner_get_more.jpg": 283,
	"./frontend_application/bell": 284,
	"./frontend_application/bell.png": 284,
	"./frontend_application/bg-upgrade": 285,
	"./frontend_application/bg-upgrade-text": 286,
	"./frontend_application/bg-upgrade-text-ipad": 287,
	"./frontend_application/bg-upgrade-text-ipad.png": 287,
	"./frontend_application/bg-upgrade-text-mobile": 288,
	"./frontend_application/bg-upgrade-text-mobile.png": 288,
	"./frontend_application/bg-upgrade-text.png": 286,
	"./frontend_application/bg-upgrade.png": 285,
	"./frontend_application/booking-banner": 289,
	"./frontend_application/booking-banner.jpg": 289,
	"./frontend_application/bottomnav/favourite": 290,
	"./frontend_application/bottomnav/favourite.svg": 290,
	"./frontend_application/bottomnav/marker": 291,
	"./frontend_application/bottomnav/marker.svg": 291,
	"./frontend_application/bottomnav/notification": 292,
	"./frontend_application/bottomnav/notification.svg": 292,
	"./frontend_application/bottomnav/profile": 293,
	"./frontend_application/bottomnav/profile.svg": 293,
	"./frontend_application/bottomnav/search": 294,
	"./frontend_application/bottomnav/search.svg": 294,
	"./frontend_application/bulb": 295,
	"./frontend_application/bulb.png": 295,
	"./frontend_application/celebrate-icon": 296,
	"./frontend_application/celebrate-icon.png": 296,
	"./frontend_application/christmas/bg-bottom": 297,
	"./frontend_application/christmas/bg-bottom.png": 297,
	"./frontend_application/christmas/bg-top": 298,
	"./frontend_application/christmas/bg-top.png": 298,
	"./frontend_application/christmas/bottom-decoration": 299,
	"./frontend_application/christmas/bottom-decoration.png": 299,
	"./frontend_application/christmas/boxes": 300,
	"./frontend_application/christmas/boxes.png": 300,
	"./frontend_application/christmas/campaign-one": 301,
	"./frontend_application/christmas/campaign-one.png": 301,
	"./frontend_application/christmas/campaign-three": 302,
	"./frontend_application/christmas/campaign-three.png": 302,
	"./frontend_application/christmas/campaign-two": 303,
	"./frontend_application/christmas/campaign-two.png": 303,
	"./frontend_application/christmas/candy-icon": 304,
	"./frontend_application/christmas/candy-icon.png": 304,
	"./frontend_application/christmas/candy-one": 305,
	"./frontend_application/christmas/candy-one.png": 305,
	"./frontend_application/christmas/candy-two": 306,
	"./frontend_application/christmas/candy-two.png": 306,
	"./frontend_application/christmas/christmas_desktop": 307,
	"./frontend_application/christmas/christmas_desktop.png": 307,
	"./frontend_application/christmas/christmas_mobile": 308,
	"./frontend_application/christmas/christmas_mobile.png": 308,
	"./frontend_application/christmas/fortune-wheel": 309,
	"./frontend_application/christmas/fortune-wheel.png": 309,
	"./frontend_application/christmas/partner-five": 310,
	"./frontend_application/christmas/partner-five.png": 310,
	"./frontend_application/christmas/partner-four": 311,
	"./frontend_application/christmas/partner-four.png": 311,
	"./frontend_application/christmas/partner-one": 312,
	"./frontend_application/christmas/partner-one.png": 312,
	"./frontend_application/christmas/partner-three": 313,
	"./frontend_application/christmas/partner-three.png": 313,
	"./frontend_application/christmas/partner-two": 314,
	"./frontend_application/christmas/partner-two.png": 314,
	"./frontend_application/christmas/play-background": 315,
	"./frontend_application/christmas/play-background.png": 315,
	"./frontend_application/christmas/play-logo": 316,
	"./frontend_application/christmas/play-logo.png": 316,
	"./frontend_application/christmas/star-icon": 317,
	"./frontend_application/christmas/star-icon.png": 317,
	"./frontend_application/christmas/top-decoration": 318,
	"./frontend_application/christmas/top-decoration.png": 318,
	"./frontend_application/christmas/wheel-icon": 319,
	"./frontend_application/christmas/wheel-icon.png": 319,
	"./frontend_application/content_production/Ray-Ban": 320,
	"./frontend_application/content_production/Ray-Ban.png": 320,
	"./frontend_application/content_production/bg_bottom": 321,
	"./frontend_application/content_production/bg_bottom.png": 321,
	"./frontend_application/content_production/bg_testi": 322,
	"./frontend_application/content_production/bg_testi.png": 322,
	"./frontend_application/content_production/bg_top": 323,
	"./frontend_application/content_production/bg_top.png": 323,
	"./frontend_application/content_production/client_1": 324,
	"./frontend_application/content_production/client_1.png": 324,
	"./frontend_application/content_production/client_10": 325,
	"./frontend_application/content_production/client_10.png": 325,
	"./frontend_application/content_production/client_11": 326,
	"./frontend_application/content_production/client_11.png": 326,
	"./frontend_application/content_production/client_12": 327,
	"./frontend_application/content_production/client_12.png": 327,
	"./frontend_application/content_production/client_13": 328,
	"./frontend_application/content_production/client_13.png": 328,
	"./frontend_application/content_production/client_14": 329,
	"./frontend_application/content_production/client_14.png": 329,
	"./frontend_application/content_production/client_2": 330,
	"./frontend_application/content_production/client_2.png": 330,
	"./frontend_application/content_production/client_3": 331,
	"./frontend_application/content_production/client_3.png": 331,
	"./frontend_application/content_production/client_4": 332,
	"./frontend_application/content_production/client_4.png": 332,
	"./frontend_application/content_production/client_5": 333,
	"./frontend_application/content_production/client_5.png": 333,
	"./frontend_application/content_production/client_6": 334,
	"./frontend_application/content_production/client_6.png": 334,
	"./frontend_application/content_production/client_7": 335,
	"./frontend_application/content_production/client_7.png": 335,
	"./frontend_application/content_production/client_8": 336,
	"./frontend_application/content_production/client_8.png": 336,
	"./frontend_application/content_production/client_9": 337,
	"./frontend_application/content_production/client_9.png": 337,
	"./frontend_application/content_production/client_six": 338,
	"./frontend_application/content_production/client_six.png": 338,
	"./frontend_application/content_production/image": 339,
	"./frontend_application/content_production/image.png": 339,
	"./frontend_application/content_production/other_service_one": 340,
	"./frontend_application/content_production/other_service_one.png": 340,
	"./frontend_application/content_production/other_service_three": 341,
	"./frontend_application/content_production/other_service_three.png": 341,
	"./frontend_application/content_production/other_service_two": 342,
	"./frontend_application/content_production/other_service_two.png": 342,
	"./frontend_application/content_production/service_img": 343,
	"./frontend_application/content_production/service_img.png": 343,
	"./frontend_application/content_production/top_service_one": 344,
	"./frontend_application/content_production/top_service_one.png": 344,
	"./frontend_application/content_production/top_service_three": 345,
	"./frontend_application/content_production/top_service_three.png": 345,
	"./frontend_application/content_production/top_service_two": 346,
	"./frontend_application/content_production/top_service_two.png": 346,
	"./frontend_application/content_production/user_one": 347,
	"./frontend_application/content_production/user_one.png": 347,
	"./frontend_application/content_production/user_three": 348,
	"./frontend_application/content_production/user_three.jpeg": 348,
	"./frontend_application/content_production/user_two": 349,
	"./frontend_application/content_production/user_two.png": 349,
	"./frontend_application/controls": 350,
	"./frontend_application/controls.png": 350,
	"./frontend_application/country/hk": 351,
	"./frontend_application/country/hk.jpg": 351,
	"./frontend_application/country/id": 352,
	"./frontend_application/country/id.jpg": 352,
	"./frontend_application/country/my": 353,
	"./frontend_application/country/my.jpg": 353,
	"./frontend_application/country/ph": 354,
	"./frontend_application/country/ph.jpg": 354,
	"./frontend_application/country/sg": 355,
	"./frontend_application/country/sg.jpg": 355,
	"./frontend_application/coupon-blue": 356,
	"./frontend_application/coupon-blue.png": 356,
	"./frontend_application/coupon-green": 357,
	"./frontend_application/coupon-green.png": 357,
	"./frontend_application/coupon-orange": 358,
	"./frontend_application/coupon-orange.png": 358,
	"./frontend_application/coupon-purple": 359,
	"./frontend_application/coupon-purple.png": 359,
	"./frontend_application/coupon-red": 360,
	"./frontend_application/coupon-red.png": 360,
	"./frontend_application/data-deals-icon": 361,
	"./frontend_application/data-deals-icon.png": 361,
	"./frontend_application/delete-icon": 362,
	"./frontend_application/delete-icon.png": 362,
	"./frontend_application/document-blank": 363,
	"./frontend_application/document-blank.png": 363,
	"./frontend_application/down-icon": 364,
	"./frontend_application/down-icon.svg": 364,
	"./frontend_application/edit-icon": 365,
	"./frontend_application/edit-icon.png": 365,
	"./frontend_application/eventtype/baby": 366,
	"./frontend_application/eventtype/baby.jpg": 366,
	"./frontend_application/eventtype/birthday": 367,
	"./frontend_application/eventtype/birthday.jpg": 367,
	"./frontend_application/eventtype/dinner": 368,
	"./frontend_application/eventtype/dinner.jpg": 368,
	"./frontend_application/eventtype/dnd": 369,
	"./frontend_application/eventtype/dnd.jpg": 369,
	"./frontend_application/eventtype/meeting": 370,
	"./frontend_application/eventtype/meeting.jpg": 370,
	"./frontend_application/eventtype/seminar": 371,
	"./frontend_application/eventtype/seminar.jpg": 371,
	"./frontend_application/eventtype/wedding": 372,
	"./frontend_application/eventtype/wedding.jpg": 372,
	"./frontend_application/fast-enquiry-bg": 373,
	"./frontend_application/fast-enquiry-bg.jpg": 373,
	"./frontend_application/fast-enquiry-btn-icon": 374,
	"./frontend_application/fast-enquiry-btn-icon.png": 374,
	"./frontend_application/fast-enquiry-icon": 375,
	"./frontend_application/fast-enquiry-icon.png": 375,
	"./frontend_application/favicon-196x196": 376,
	"./frontend_application/favicon-196x196.png": 376,
	"./frontend_application/filter-icon": 377,
	"./frontend_application/filter-icon.png": 377,
	"./frontend_application/footericon/blog": 378,
	"./frontend_application/footericon/blog.svg": 378,
	"./frontend_application/footericon/facebook": 379,
	"./frontend_application/footericon/facebook.svg": 379,
	"./frontend_application/footericon/instagram": 380,
	"./frontend_application/footericon/instagram.svg": 380,
	"./frontend_application/footericon/linkedin": 381,
	"./frontend_application/footericon/linkedin.svg": 381,
	"./frontend_application/footericon/mailto": 382,
	"./frontend_application/footericon/mailto.svg": 382,
	"./frontend_application/footericon/pinterest": 383,
	"./frontend_application/footericon/pinterest.svg": 383,
	"./frontend_application/footericon/telegram": 384,
	"./frontend_application/footericon/telegram.svg": 384,
	"./frontend_application/footericon/tiktok": 385,
	"./frontend_application/footericon/tiktok.svg": 385,
	"./frontend_application/footericon/youtube": 386,
	"./frontend_application/footericon/youtube.svg": 386,
	"./frontend_application/free_trial/banner_img": 387,
	"./frontend_application/free_trial/banner_img.png": 387,
	"./frontend_application/free_trial/calendar": 388,
	"./frontend_application/free_trial/calendar.png": 388,
	"./frontend_application/free_trial/calendar_icon": 389,
	"./frontend_application/free_trial/calendar_icon.png": 389,
	"./frontend_application/free_trial/client": 390,
	"./frontend_application/free_trial/client.png": 390,
	"./frontend_application/free_trial/client_five": 391,
	"./frontend_application/free_trial/client_five.png": 391,
	"./frontend_application/free_trial/client_four": 392,
	"./frontend_application/free_trial/client_four.png": 392,
	"./frontend_application/free_trial/client_one": 393,
	"./frontend_application/free_trial/client_one.png": 393,
	"./frontend_application/free_trial/client_three": 394,
	"./frontend_application/free_trial/client_three.png": 394,
	"./frontend_application/free_trial/client_two": 395,
	"./frontend_application/free_trial/client_two.png": 395,
	"./frontend_application/free_trial/crm": 396,
	"./frontend_application/free_trial/crm.png": 396,
	"./frontend_application/free_trial/crm_icon": 397,
	"./frontend_application/free_trial/crm_icon.png": 397,
	"./frontend_application/free_trial/email": 398,
	"./frontend_application/free_trial/email.png": 398,
	"./frontend_application/free_trial/feature_background": 399,
	"./frontend_application/free_trial/feature_background.png": 399,
	"./frontend_application/free_trial/feature_five": 400,
	"./frontend_application/free_trial/feature_five.png": 400,
	"./frontend_application/free_trial/feature_four": 401,
	"./frontend_application/free_trial/feature_four.png": 401,
	"./frontend_application/free_trial/feature_one": 402,
	"./frontend_application/free_trial/feature_one.png": 402,
	"./frontend_application/free_trial/feature_three": 403,
	"./frontend_application/free_trial/feature_three.png": 403,
	"./frontend_application/free_trial/feature_two": 404,
	"./frontend_application/free_trial/feature_two.png": 404,
	"./frontend_application/free_trial/header_background": 405,
	"./frontend_application/free_trial/header_background.png": 405,
	"./frontend_application/free_trial/heading_banner_blue": 406,
	"./frontend_application/free_trial/heading_banner_blue.png": 406,
	"./frontend_application/free_trial/heading_banner_purple": 407,
	"./frontend_application/free_trial/heading_banner_purple.png": 407,
	"./frontend_application/free_trial/icon-calendar-lg": 408,
	"./frontend_application/free_trial/icon-calendar-lg.png": 408,
	"./frontend_application/free_trial/icon-crm-lg": 409,
	"./frontend_application/free_trial/icon-crm-lg.png": 409,
	"./frontend_application/free_trial/icon-marketing-lg": 410,
	"./frontend_application/free_trial/icon-marketing-lg.png": 410,
	"./frontend_application/free_trial/icon-payment-lg": 411,
	"./frontend_application/free_trial/icon-payment-lg.png": 411,
	"./frontend_application/free_trial/icon-stats-lg": 412,
	"./frontend_application/free_trial/icon-stats-lg.png": 412,
	"./frontend_application/free_trial/icon-venue-lg": 413,
	"./frontend_application/free_trial/icon-venue-lg.png": 413,
	"./frontend_application/free_trial/integrated_icon": 414,
	"./frontend_application/free_trial/integrated_icon.png": 414,
	"./frontend_application/free_trial/payment": 415,
	"./frontend_application/free_trial/payment.png": 415,
	"./frontend_application/free_trial/payment_icon": 416,
	"./frontend_application/free_trial/payment_icon.png": 416,
	"./frontend_application/free_trial/psg_one": 417,
	"./frontend_application/free_trial/psg_one.png": 417,
	"./frontend_application/free_trial/psg_two": 418,
	"./frontend_application/free_trial/psg_two.png": 418,
	"./frontend_application/free_trial/quote_img": 419,
	"./frontend_application/free_trial/quote_img.png": 419,
	"./frontend_application/free_trial/report": 420,
	"./frontend_application/free_trial/report.png": 420,
	"./frontend_application/free_trial/report_icon": 421,
	"./frontend_application/free_trial/report_icon.png": 421,
	"./frontend_application/free_trial/room_icon": 422,
	"./frontend_application/free_trial/room_icon.png": 422,
	"./frontend_application/free_trial/service_one": 423,
	"./frontend_application/free_trial/service_one.png": 423,
	"./frontend_application/free_trial/service_three": 424,
	"./frontend_application/free_trial/service_three.png": 424,
	"./frontend_application/free_trial/service_two": 425,
	"./frontend_application/free_trial/service_two.png": 425,
	"./frontend_application/free_trial/venue": 426,
	"./frontend_application/free_trial/venue.png": 426,
	"./frontend_application/free_trial/venuerific_logo": 427,
	"./frontend_application/free_trial/venuerific_logo.png": 427,
	"./frontend_application/good_bye": 428,
	"./frontend_application/good_bye.png": 428,
	"./frontend_application/help/bg-help": 429,
	"./frontend_application/help/bg-help.png": 429,
	"./frontend_application/homepage_reward_desktop": 430,
	"./frontend_application/homepage_reward_desktop.png": 430,
	"./frontend_application/homepage_reward_mobile": 431,
	"./frontend_application/homepage_reward_mobile.png": 431,
	"./frontend_application/img-banner": 432,
	"./frontend_application/img-banner.png": 432,
	"./frontend_application/img-icon": 433,
	"./frontend_application/img-icon.png": 433,
	"./frontend_application/landing-faq": 54,
	"./frontend_application/landing-faq.png": 54,
	"./frontend_application/landing-faq.webp": 900,
	"./frontend_application/laptop": 55,
	"./frontend_application/laptop.png": 55,
	"./frontend_application/laptop.webp": 901,
	"./frontend_application/logo-footer": 434,
	"./frontend_application/logo-footer.png": 434,
	"./frontend_application/logs-blank": 435,
	"./frontend_application/logs-blank.png": 435,
	"./frontend_application/map/hongkong": 436,
	"./frontend_application/map/hongkong.webp": 436,
	"./frontend_application/map/indonesia": 437,
	"./frontend_application/map/indonesia.webp": 437,
	"./frontend_application/map/malaysia": 438,
	"./frontend_application/map/malaysia.webp": 438,
	"./frontend_application/map/philippines": 439,
	"./frontend_application/map/philippines.webp": 439,
	"./frontend_application/map/singapore": 440,
	"./frontend_application/map/singapore.webp": 440,
	"./frontend_application/master_card": 56,
	"./frontend_application/master_card.png": 56,
	"./frontend_application/master_card.svg": 902,
	"./frontend_application/multi-data-icon": 441,
	"./frontend_application/multi-data-icon.png": 441,
	"./frontend_application/myfavourite-blank": 442,
	"./frontend_application/myfavourite-blank.png": 442,
	"./frontend_application/myhosting/call": 443,
	"./frontend_application/myhosting/call.png": 443,
	"./frontend_application/myhosting/completed": 444,
	"./frontend_application/myhosting/completed.png": 444,
	"./frontend_application/myhosting/email": 445,
	"./frontend_application/myhosting/email.png": 445,
	"./frontend_application/myhosting/paid": 446,
	"./frontend_application/myhosting/paid.png": 446,
	"./frontend_application/myhosting/pending": 447,
	"./frontend_application/myhosting/pending.png": 447,
	"./frontend_application/myhosting/quote_required": 448,
	"./frontend_application/myhosting/quote_required.png": 448,
	"./frontend_application/myhosting/rejected": 449,
	"./frontend_application/myhosting/rejected.png": 449,
	"./frontend_application/myhosting/reviewed": 450,
	"./frontend_application/myhosting/reviewed.png": 450,
	"./frontend_application/myhosting/scheduled": 451,
	"./frontend_application/myhosting/scheduled.png": 451,
	"./frontend_application/myhosting/site_visit": 452,
	"./frontend_application/myhosting/site_visit.png": 452,
	"./frontend_application/myhosting/unpaid": 453,
	"./frontend_application/myhosting/unpaid.png": 453,
	"./frontend_application/myhosting/urgent_request": 454,
	"./frontend_application/myhosting/urgent_request.png": 454,
	"./frontend_application/myhosting/whatsapp": 455,
	"./frontend_application/myhosting/whatsapp.png": 455,
	"./frontend_application/myinvitation-blank": 456,
	"./frontend_application/myinvitation-blank.png": 456,
	"./frontend_application/nav-logo": 457,
	"./frontend_application/nav-logo-christmas": 458,
	"./frontend_application/nav-logo-christmas.png": 458,
	"./frontend_application/nav-logo-white": 459,
	"./frontend_application/nav-logo-white-christmas": 460,
	"./frontend_application/nav-logo-white-christmas.png": 460,
	"./frontend_application/nav-logo-white.png": 459,
	"./frontend_application/nav-logo.png": 457,
	"./frontend_application/navicon/black-fav-icon": 461,
	"./frontend_application/navicon/black-fav-icon.svg": 461,
	"./frontend_application/navicon/black-notif-icon": 462,
	"./frontend_application/navicon/black-notif-icon.svg": 462,
	"./frontend_application/navicon/white-fav-icon": 463,
	"./frontend_application/navicon/white-fav-icon.svg": 463,
	"./frontend_application/navicon/white-notif-icon": 464,
	"./frontend_application/navicon/white-notif-icon.svg": 464,
	"./frontend_application/news-placeholder": 465,
	"./frontend_application/news-placeholder.svg": 465,
	"./frontend_application/no-photo-venue": 466,
	"./frontend_application/no-photo-venue.jpg": 466,
	"./frontend_application/nogroup": 467,
	"./frontend_application/nogroup.png": 467,
	"./frontend_application/noinquiries": 468,
	"./frontend_application/noinquiries.png": 468,
	"./frontend_application/noroom": 469,
	"./frontend_application/noroom.png": 469,
	"./frontend_application/notification/event_planner/enquiry_accepted": 470,
	"./frontend_application/notification/event_planner/enquiry_accepted.png": 470,
	"./frontend_application/notification/event_planner/enquiry_declined": 471,
	"./frontend_application/notification/event_planner/enquiry_declined.png": 471,
	"./frontend_application/notification/event_planner/enquiry_read": 472,
	"./frontend_application/notification/event_planner/enquiry_read.png": 472,
	"./frontend_application/notification/event_planner/enquiry_sent": 473,
	"./frontend_application/notification/event_planner/enquiry_sent.png": 473,
	"./frontend_application/notification/event_planner/event_finished": 474,
	"./frontend_application/notification/event_planner/event_finished.png": 474,
	"./frontend_application/notification/event_planner/invoice_sent": 475,
	"./frontend_application/notification/event_planner/invoice_sent.png": 475,
	"./frontend_application/notification/event_planner/news_created": 476,
	"./frontend_application/notification/event_planner/news_created.png": 476,
	"./frontend_application/notification/event_planner/profile_incomplete": 477,
	"./frontend_application/notification/event_planner/profile_incomplete.png": 477,
	"./frontend_application/notification/venue_owner/call_missed": 478,
	"./frontend_application/notification/venue_owner/call_missed.png": 478,
	"./frontend_application/notification/venue_owner/enquiry_accepted": 479,
	"./frontend_application/notification/venue_owner/enquiry_accepted.png": 479,
	"./frontend_application/notification/venue_owner/enquiry_sent": 480,
	"./frontend_application/notification/venue_owner/enquiry_sent.png": 480,
	"./frontend_application/notification/venue_owner/enquiry_unread": 481,
	"./frontend_application/notification/venue_owner/enquiry_unread.png": 481,
	"./frontend_application/notification/venue_owner/event_finished": 482,
	"./frontend_application/notification/venue_owner/event_finished.png": 482,
	"./frontend_application/notification/venue_owner/goal_empty": 483,
	"./frontend_application/notification/venue_owner/goal_empty.png": 483,
	"./frontend_application/notification/venue_owner/goal_unmet": 484,
	"./frontend_application/notification/venue_owner/goal_unmet.png": 484,
	"./frontend_application/notification/venue_owner/payment_submitted": 485,
	"./frontend_application/notification/venue_owner/payment_submitted.png": 485,
	"./frontend_application/notification/venue_owner/profile_missing_phone_number": 486,
	"./frontend_application/notification/venue_owner/profile_missing_phone_number.png": 486,
	"./frontend_application/notification/venue_owner/profile_missing_picture": 487,
	"./frontend_application/notification/venue_owner/profile_missing_picture.png": 487,
	"./frontend_application/notification/venue_owner/promotion_empty": 488,
	"./frontend_application/notification/venue_owner/promotion_empty.png": 488,
	"./frontend_application/notification/venue_owner/review_received": 489,
	"./frontend_application/notification/venue_owner/review_received.png": 489,
	"./frontend_application/notification/venue_owner/stats_summarized": 490,
	"./frontend_application/notification/venue_owner/stats_summarized.png": 490,
	"./frontend_application/nouser_placeholder": 491,
	"./frontend_application/nouser_placeholder.svg": 491,
	"./frontend_application/package-icon": 492,
	"./frontend_application/package-icon.svg": 492,
	"./frontend_application/paper-icon": 493,
	"./frontend_application/paper-icon.svg": 493,
	"./frontend_application/payment-icon": 494,
	"./frontend_application/payment-icon.png": 494,
	"./frontend_application/profile_completed_icon": 495,
	"./frontend_application/profile_completed_icon.svg": 495,
	"./frontend_application/promo-badge": 496,
	"./frontend_application/promo-badge.png": 496,
	"./frontend_application/promo-banner-md": 497,
	"./frontend_application/promo-banner-md.png": 497,
	"./frontend_application/promo-banner-sm": 498,
	"./frontend_application/promo-banner-sm.png": 498,
	"./frontend_application/promo-blank": 499,
	"./frontend_application/promo-blank.png": 499,
	"./frontend_application/promo-icon": 500,
	"./frontend_application/promo-icon.png": 500,
	"./frontend_application/question": 501,
	"./frontend_application/question.png": 501,
	"./frontend_application/review-blank": 502,
	"./frontend_application/review-blank.png": 502,
	"./frontend_application/reward-icon": 503,
	"./frontend_application/reward-icon-lg": 504,
	"./frontend_application/reward-icon-lg.png": 504,
	"./frontend_application/reward-icon.png": 503,
	"./frontend_application/reward_bg": 505,
	"./frontend_application/reward_bg.png": 505,
	"./frontend_application/reward_img": 506,
	"./frontend_application/reward_img.jpg": 506,
	"./frontend_application/sad": 507,
	"./frontend_application/sad.png": 507,
	"./frontend_application/single-data-icon": 508,
	"./frontend_application/single-data-icon.png": 508,
	"./frontend_application/snap": 509,
	"./frontend_application/snap.png": 509,
	"./frontend_application/solution/venuerificpay": 510,
	"./frontend_application/solution/venuerificpay.jpg": 510,
	"./frontend_application/solution/videoprod": 511,
	"./frontend_application/solution/videoprod.jpg": 511,
	"./frontend_application/solution/virtualwedding": 512,
	"./frontend_application/solution/virtualwedding.jpg": 512,
	"./frontend_application/star": 513,
	"./frontend_application/star.png": 513,
	"./frontend_application/stats/icon-bounced": 514,
	"./frontend_application/stats/icon-bounced.png": 514,
	"./frontend_application/stats/icon-clicked": 515,
	"./frontend_application/stats/icon-clicked.png": 515,
	"./frontend_application/stats/icon-clock": 516,
	"./frontend_application/stats/icon-clock.png": 516,
	"./frontend_application/stats/icon-opened": 517,
	"./frontend_application/stats/icon-opened.png": 517,
	"./frontend_application/stats/icon-park_ranking": 518,
	"./frontend_application/stats/icon-park_ranking.png": 518,
	"./frontend_application/stats/icon-send-check": 519,
	"./frontend_application/stats/icon-send-check.png": 519,
	"./frontend_application/stats/icon-unsubscribed": 520,
	"./frontend_application/stats/icon-unsubscribed.png": 520,
	"./frontend_application/stripe-gray-img": 521,
	"./frontend_application/stripe-gray-img.svg": 521,
	"./frontend_application/stripe-img": 522,
	"./frontend_application/stripe-img.png": 522,
	"./frontend_application/subpupgrade": 523,
	"./frontend_application/subpupgrade.png": 523,
	"./frontend_application/three-sixty-icon-sm": 524,
	"./frontend_application/three-sixty-icon-sm.png": 524,
	"./frontend_application/thumb": 525,
	"./frontend_application/thumb.png": 525,
	"./frontend_application/todo-empty": 526,
	"./frontend_application/todo-empty.png": 526,
	"./frontend_application/up-icon": 527,
	"./frontend_application/up-icon.svg": 527,
	"./frontend_application/upload-icon": 528,
	"./frontend_application/upload-icon.jpg": 528,
	"./frontend_application/upload-placeholder": 529,
	"./frontend_application/upload-placeholder.svg": 529,
	"./frontend_application/usernav": 530,
	"./frontend_application/usernav.png": 530,
	"./frontend_application/vca-award-badge": 531,
	"./frontend_application/vca-award-badge.gif": 531,
	"./frontend_application/venue/account-grey": 532,
	"./frontend_application/venue/account-grey.png": 532,
	"./frontend_application/venue/account-img": 533,
	"./frontend_application/venue/account-img.png": 533,
	"./frontend_application/venue/airconditioner-icon": 534,
	"./frontend_application/venue/airconditioner-icon.png": 534,
	"./frontend_application/venue/amp-icon": 535,
	"./frontend_application/venue/amp-icon.png": 535,
	"./frontend_application/venue/availability-icon": 536,
	"./frontend_application/venue/availability-icon.png": 536,
	"./frontend_application/venue/bar-icon": 537,
	"./frontend_application/venue/bar-icon.png": 537,
	"./frontend_application/venue/bar-tab-icon": 538,
	"./frontend_application/venue/bar-tab-icon.png": 538,
	"./frontend_application/venue/boardgame-icon": 539,
	"./frontend_application/venue/boardgame-icon.png": 539,
	"./frontend_application/venue/book-icon": 540,
	"./frontend_application/venue/book-icon.png": 540,
	"./frontend_application/venue/bus-icon": 541,
	"./frontend_application/venue/bus-icon.png": 541,
	"./frontend_application/venue/card-icon": 542,
	"./frontend_application/venue/card-icon.png": 542,
	"./frontend_application/venue/catering-icon": 543,
	"./frontend_application/venue/catering-icon.png": 543,
	"./frontend_application/venue/chair-icon": 544,
	"./frontend_application/venue/chair-icon.png": 544,
	"./frontend_application/venue/coffe-icon": 545,
	"./frontend_application/venue/coffe-icon.png": 545,
	"./frontend_application/venue/custom-accesibility-icon": 546,
	"./frontend_application/venue/custom-accesibility-icon.png": 546,
	"./frontend_application/venue/darts-icon": 547,
	"./frontend_application/venue/darts-icon.png": 547,
	"./frontend_application/venue/discount-icon": 548,
	"./frontend_application/venue/discount-icon.png": 548,
	"./frontend_application/venue/djconsole-icon": 549,
	"./frontend_application/venue/djconsole-icon.png": 549,
	"./frontend_application/venue/email-icon": 550,
	"./frontend_application/venue/email-icon.png": 550,
	"./frontend_application/venue/enquiry-white-icon": 551,
	"./frontend_application/venue/enquiry-white-icon.png": 551,
	"./frontend_application/venue/eventstaff-icon": 552,
	"./frontend_application/venue/eventstaff-icon.png": 552,
	"./frontend_application/venue/exclamation-icon": 553,
	"./frontend_application/venue/exclamation-icon.png": 553,
	"./frontend_application/venue/fb-icon": 554,
	"./frontend_application/venue/fb-icon.png": 554,
	"./frontend_application/venue/food-icon": 555,
	"./frontend_application/venue/food-icon.png": 555,
	"./frontend_application/venue/fullbar-icon": 556,
	"./frontend_application/venue/fullbar-icon.png": 556,
	"./frontend_application/venue/game-icon": 557,
	"./frontend_application/venue/game-icon.png": 557,
	"./frontend_application/venue/karaoke-icon": 558,
	"./frontend_application/venue/karaoke-icon.png": 558,
	"./frontend_application/venue/linkedin-icon": 559,
	"./frontend_application/venue/linkedin-icon.png": 559,
	"./frontend_application/venue/mic-icon": 560,
	"./frontend_application/venue/mic-icon.png": 560,
	"./frontend_application/venue/mrt-icon": 561,
	"./frontend_application/venue/mrt-icon.png": 561,
	"./frontend_application/venue/offer-icon": 562,
	"./frontend_application/venue/offer-icon.png": 562,
	"./frontend_application/venue/other-amenties-icon": 563,
	"./frontend_application/venue/other-amenties-icon.png": 563,
	"./frontend_application/venue/package-deals-icon": 564,
	"./frontend_application/venue/package-deals-icon.png": 564,
	"./frontend_application/venue/package-icon": 565,
	"./frontend_application/venue/package-icon.png": 565,
	"./frontend_application/venue/papers-icon": 566,
	"./frontend_application/venue/papers-icon.png": 566,
	"./frontend_application/venue/park-icon": 567,
	"./frontend_application/venue/park-icon.png": 567,
	"./frontend_application/venue/pencil-icon": 568,
	"./frontend_application/venue/pencil-icon.png": 568,
	"./frontend_application/venue/pingpong-icon": 569,
	"./frontend_application/venue/pingpong-icon.png": 569,
	"./frontend_application/venue/pool-table-icon": 570,
	"./frontend_application/venue/pool-table-icon.png": 570,
	"./frontend_application/venue/privateroom-icon": 571,
	"./frontend_application/venue/privateroom-icon.png": 571,
	"./frontend_application/venue/projector-icon": 572,
	"./frontend_application/venue/projector-icon.png": 572,
	"./frontend_application/venue/recycle-bin-icon": 573,
	"./frontend_application/venue/recycle-bin-icon.png": 573,
	"./frontend_application/venue/restaurant-icon": 574,
	"./frontend_application/venue/restaurant-icon.png": 574,
	"./frontend_application/venue/room-icon": 575,
	"./frontend_application/venue/room-icon.png": 575,
	"./frontend_application/venue/rules-icon": 576,
	"./frontend_application/venue/rules-icon.png": 576,
	"./frontend_application/venue/seats-icon": 577,
	"./frontend_application/venue/seats-icon.png": 577,
	"./frontend_application/venue/size-icon": 578,
	"./frontend_application/venue/size-icon.png": 578,
	"./frontend_application/venue/smoking-icon": 579,
	"./frontend_application/venue/smoking-icon.png": 579,
	"./frontend_application/venue/soundsystem-icon": 580,
	"./frontend_application/venue/soundsystem-icon.png": 580,
	"./frontend_application/venue/stage-icon": 581,
	"./frontend_application/venue/stage-icon.png": 581,
	"./frontend_application/venue/standing-icon": 582,
	"./frontend_application/venue/standing-icon.png": 582,
	"./frontend_application/venue/street-park-icon": 583,
	"./frontend_application/venue/street-park-icon.png": 583,
	"./frontend_application/venue/suitcase-icon": 584,
	"./frontend_application/venue/suitcase-icon.png": 584,
	"./frontend_application/venue/swim-icon": 585,
	"./frontend_application/venue/swim-icon.png": 585,
	"./frontend_application/venue/table-icon": 586,
	"./frontend_application/venue/table-icon.png": 586,
	"./frontend_application/venue/taxi-icon": 587,
	"./frontend_application/venue/taxi-icon.png": 587,
	"./frontend_application/venue/tea-icon": 588,
	"./frontend_application/venue/tea-icon.png": 588,
	"./frontend_application/venue/techsupport-icon": 589,
	"./frontend_application/venue/techsupport-icon.png": 589,
	"./frontend_application/venue/tv-icon": 590,
	"./frontend_application/venue/tv-icon.png": 590,
	"./frontend_application/venue/twitter-icon": 591,
	"./frontend_application/venue/twitter-icon.png": 591,
	"./frontend_application/venue/valet-icon": 592,
	"./frontend_application/venue/valet-icon.png": 592,
	"./frontend_application/venue/venue-img-five": 593,
	"./frontend_application/venue/venue-img-five.jpg": 593,
	"./frontend_application/venue/venue-img-four": 594,
	"./frontend_application/venue/venue-img-four.jpg": 594,
	"./frontend_application/venue/venue-img-one": 595,
	"./frontend_application/venue/venue-img-one.jpg": 595,
	"./frontend_application/venue/venue-img-three": 596,
	"./frontend_application/venue/venue-img-three.jpg": 596,
	"./frontend_application/venue/venue-img-two": 597,
	"./frontend_application/venue/venue-img-two.jpg": 597,
	"./frontend_application/venue/whatsapp-icon": 598,
	"./frontend_application/venue/whatsapp-icon.png": 598,
	"./frontend_application/venue/whatsapp-lg-icon": 599,
	"./frontend_application/venue/whatsapp-lg-icon.png": 599,
	"./frontend_application/venue/whatsapp-white-icon": 600,
	"./frontend_application/venue/whatsapp-white-icon.png": 600,
	"./frontend_application/venue/whiteboard-icon": 601,
	"./frontend_application/venue/whiteboard-icon.png": 601,
	"./frontend_application/venue/wifi-icon": 602,
	"./frontend_application/venue/wifi-icon.png": 602,
	"./frontend_application/video-icon": 603,
	"./frontend_application/video-icon-sm": 604,
	"./frontend_application/video-icon-sm.png": 604,
	"./frontend_application/video-icon.png": 603,
	"./frontend_application/visa": 57,
	"./frontend_application/visa.png": 57,
	"./frontend_application/visa.svg": 903,
	"./frontend_application/vnfc-bank-logo": 605,
	"./frontend_application/vnfc-bank-logo.svg": 605,
	"./frontend_application/vnfc-new-pay-logo": 606,
	"./frontend_application/vnfc-new-pay-logo.svg": 606,
	"./frontend_application/vnfc-pay-logo": 607,
	"./frontend_application/vnfc-pay-logo.png": 607,
	"./google-icon": 608,
	"./google-icon.png": 608,
	"./hk": 609,
	"./hk.png": 609,
	"./home/banner_flashdeal": 610,
	"./home/banner_flashdeal.png": 610,
	"./home/bg-home": 611,
	"./home/bg-home.png": 611,
	"./home/btn_next": 612,
	"./home/btn_next.png": 612,
	"./home/btn_prev": 613,
	"./home/btn_prev.png": 613,
	"./home/img_baby-shower": 614,
	"./home/img_baby-shower.png": 614,
	"./home/img_badge": 615,
	"./home/img_badge.png": 615,
	"./home/img_birthday-party": 616,
	"./home/img_birthday-party.png": 616,
	"./home/img_company-dinner-and-dance": 617,
	"./home/img_company-dinner-and-dance.png": 617,
	"./home/img_corporate-seminar": 618,
	"./home/img_corporate-seminar.png": 618,
	"./home/img_hk": 619,
	"./home/img_hk.png": 619,
	"./home/img_id": 620,
	"./home/img_id.png": 620,
	"./home/img_meeting": 621,
	"./home/img_meeting.png": 621,
	"./home/img_my": 622,
	"./home/img_my.png": 622,
	"./home/img_ph": 623,
	"./home/img_ph.png": 623,
	"./home/img_sg": 624,
	"./home/img_sg.png": 624,
	"./home/img_thumb-1": 625,
	"./home/img_thumb-1.png": 625,
	"./home/img_thumb-2": 626,
	"./home/img_thumb-2.png": 626,
	"./home/img_thumb-3": 627,
	"./home/img_thumb-3.png": 627,
	"./home/img_wedding": 628,
	"./home/img_wedding.png": 628,
	"./icon1": 629,
	"./icon1.svg": 629,
	"./icon2": 630,
	"./icon2.svg": 630,
	"./icon3": 631,
	"./icon3.svg": 631,
	"./icons/chevron-left-circle": 632,
	"./icons/chevron-left-circle.png": 632,
	"./icons/favourite": 633,
	"./icons/favourite.png": 633,
	"./icons/my_venues": 634,
	"./icons/my_venues.png": 634,
	"./icons/venue_group": 635,
	"./icons/venue_group.png": 635,
	"./id": 636,
	"./id.png": 636,
	"./img-icon": 637,
	"./img-icon.png": 637,
	"./jewel": 638,
	"./jewel.png": 638,
	"./linkedin-icon": 639,
	"./linkedin-icon.png": 639,
	"./logo": 640,
	"./logo-christmas": 641,
	"./logo-christmas.png": 641,
	"./logo.png": 640,
	"./millennium": 642,
	"./millennium.png": 642,
	"./mox": 643,
	"./mox.png": 643,
	"./my": 644,
	"./my.png": 644,
	"./new-assets/emoji/party": 645,
	"./new-assets/emoji/party.png": 645,
	"./new-assets/promo-badge": 646,
	"./new-assets/promo-badge.png": 646,
	"./new-assets/user": 647,
	"./new-assets/user.png": 647,
	"./pasarbella": 648,
	"./pasarbella.png": 648,
	"./payments/calendar-icon": 649,
	"./payments/calendar-icon.svg": 649,
	"./payments/card-gray-icon": 650,
	"./payments/card-gray-icon.png": 650,
	"./payments/card-icon": 651,
	"./payments/card-icon.svg": 651,
	"./payments/credit-card": 652,
	"./payments/credit-card.svg": 652,
	"./payments/dashboard": 653,
	"./payments/dashboard.png": 653,
	"./payments/header": 654,
	"./payments/header-mobile": 655,
	"./payments/header-mobile.svg": 655,
	"./payments/header.svg": 654,
	"./payments/logo": 656,
	"./payments/logo.svg": 656,
	"./payments/monitor-icon": 657,
	"./payments/monitor-icon.svg": 657,
	"./payments/payment-illustration-1": 658,
	"./payments/payment-illustration-1.svg": 658,
	"./payments/payment-illustration-2": 659,
	"./payments/payment-illustration-2.svg": 659,
	"./payments/payment-illustration-3": 660,
	"./payments/payment-illustration-3.svg": 660,
	"./payments/payment-wrapper": 661,
	"./payments/payment-wrapper.svg": 661,
	"./payments/seamless": 662,
	"./payments/seamless.jpg": 662,
	"./payments/sites": 663,
	"./payments/sites.svg": 663,
	"./payments/web-icon": 664,
	"./payments/web-icon.svg": 664,
	"./ph": 665,
	"./ph.png": 665,
	"./private-venue/1": 666,
	"./private-venue/1.png": 666,
	"./private-venue/2": 667,
	"./private-venue/2.png": 667,
	"./private-venue/banner-main": 668,
	"./private-venue/banner-main.png": 668,
	"./private-venue/bg-benefit": 669,
	"./private-venue/bg-benefit.png": 669,
	"./private-venue/bg-cta": 670,
	"./private-venue/bg-cta.png": 670,
	"./private-venue/bg-hover-cheers": 671,
	"./private-venue/bg-hover-cheers.png": 671,
	"./private-venue/bg-hover-home": 672,
	"./private-venue/bg-hover-home.png": 672,
	"./private-venue/bg-hover-unique": 673,
	"./private-venue/bg-hover-unique.png": 673,
	"./private-venue/bg-hover-work": 674,
	"./private-venue/bg-hover-work.png": 674,
	"./private-venue/bg-stats": 675,
	"./private-venue/bg-stats.png": 675,
	"./private-venue/bridge": 676,
	"./private-venue/bridge.png": 676,
	"./private-venue/calendar": 677,
	"./private-venue/calendar.svg": 677,
	"./private-venue/chart": 678,
	"./private-venue/chart.svg": 678,
	"./private-venue/cheers": 679,
	"./private-venue/cheers.svg": 679,
	"./private-venue/csc": 680,
	"./private-venue/csc.png": 680,
	"./private-venue/distrii": 681,
	"./private-venue/distrii.png": 681,
	"./private-venue/experience": 682,
	"./private-venue/experience.svg": 682,
	"./private-venue/hover-cheers": 683,
	"./private-venue/hover-cheers.svg": 683,
	"./private-venue/hover-private": 684,
	"./private-venue/hover-private.svg": 684,
	"./private-venue/hover-unique": 685,
	"./private-venue/hover-unique.svg": 685,
	"./private-venue/hover-work": 686,
	"./private-venue/hover-work.svg": 686,
	"./private-venue/location": 687,
	"./private-venue/location.png": 687,
	"./private-venue/partnership": 688,
	"./private-venue/partnership.png": 688,
	"./private-venue/pin": 689,
	"./private-venue/pin.svg": 689,
	"./private-venue/private": 690,
	"./private-venue/private.svg": 690,
	"./private-venue/professional": 691,
	"./private-venue/professional.svg": 691,
	"./private-venue/trust": 692,
	"./private-venue/trust.svg": 692,
	"./private-venue/unique": 693,
	"./private-venue/unique.svg": 693,
	"./private-venue/wework": 694,
	"./private-venue/wework.png": 694,
	"./private-venue/work": 695,
	"./private-venue/work.svg": 695,
	"./responsive-icon": 696,
	"./responsive-icon.png": 696,
	"./room-icon": 697,
	"./room-icon.png": 697,
	"./search/bg_search_activities": 698,
	"./search/bg_search_activities.png": 698,
	"./search/yellow_buildings": 699,
	"./search/yellow_buildings.png": 699,
	"./sg": 700,
	"./sg.png": 700,
	"./skills-future-logo": 701,
	"./skills-future-logo.png": 701,
	"./slider1": 702,
	"./slider1.png": 702,
	"./slider2": 703,
	"./slider2.png": 703,
	"./super-venue/badge-card-supervenue": 704,
	"./super-venue/badge-card-supervenue.svg": 704,
	"./super-venue/badge-venue-supervenue": 705,
	"./super-venue/badge-venue-supervenue.svg": 705,
	"./super-venue/benefits1": 706,
	"./super-venue/benefits1.png": 706,
	"./super-venue/benefits2": 707,
	"./super-venue/benefits2.png": 707,
	"./super-venue/icons/badge": 708,
	"./super-venue/icons/badge.svg": 708,
	"./super-venue/icons/filter": 709,
	"./super-venue/icons/filter.svg": 709,
	"./super-venue/icons/search": 710,
	"./super-venue/icons/search.svg": 710,
	"./super-venue/icons/support": 711,
	"./super-venue/icons/support.svg": 711,
	"./super-venue/myaccount": 712,
	"./super-venue/myaccount.png": 712,
	"./super-venue/supervenue": 713,
	"./super-venue/supervenue.png": 713,
	"./testimg": 714,
	"./testimg.png": 714,
	"./testimonial/aaron_lee_all_to_gather": 715,
	"./testimonial/aaron_lee_all_to_gather.jpg": 715,
	"./testimonial/aliff": 716,
	"./testimonial/aliff.jpeg": 716,
	"./testimonial/chen": 717,
	"./testimonial/chen.jpeg": 717,
	"./testimonial/daniellim_csc": 718,
	"./testimonial/daniellim_csc.png": 718,
	"./testimonial/jonathanpang_distrii": 719,
	"./testimonial/jonathanpang_distrii.png": 719,
	"./testimonial/kanthan_jay_sk_hall": 720,
	"./testimonial/kanthan_jay_sk_hall.jpeg": 720,
	"./testimonial/ophelia": 721,
	"./testimonial/ophelia.jpeg": 721,
	"./testimonial/raymond_howe": 722,
	"./testimonial/raymond_howe.jpeg": 722,
	"./testimonial/ying": 723,
	"./testimonial/ying.png": 723,
	"./trophy-icon": 724,
	"./trophy-icon.png": 724,
	"./up-icon": 725,
	"./up-icon.svg": 725,
	"./user_blank": 726,
	"./user_blank.png": 726,
	"./vca/banner-main": 727,
	"./vca/banner-main-2022": 728,
	"./vca/banner-main-2022.png": 728,
	"./vca/banner-main.png": 727,
	"./vca/bg-about": 729,
	"./vca/bg-about-2022": 730,
	"./vca/bg-about-2022.png": 730,
	"./vca/bg-about.png": 729,
	"./vca/bg-cat": 731,
	"./vca/bg-cat.png": 731,
	"./vca/bg-category": 732,
	"./vca/bg-category.png": 732,
	"./vca/bg-category2022": 733,
	"./vca/bg-category2022.png": 733,
	"./vca/bg-howto": 734,
	"./vca/bg-howto-2022": 735,
	"./vca/bg-howto-2022.png": 735,
	"./vca/bg-howto.png": 734,
	"./vca/bg-popup": 736,
	"./vca/bg-popup-2022": 737,
	"./vca/bg-popup-2022.png": 737,
	"./vca/bg-popup-2023": 738,
	"./vca/bg-popup-2023.png": 738,
	"./vca/bg-popup.png": 736,
	"./vca/bg-sponsor": 739,
	"./vca/bg-sponsor-2022": 740,
	"./vca/bg-sponsor-2022.png": 740,
	"./vca/bg-sponsor.old": 741,
	"./vca/bg-sponsor.old.png": 741,
	"./vca/bg-sponsor.png": 739,
	"./vca/categories/cafe": 742,
	"./vca/categories/cafe.png": 742,
	"./vca/categories/innovative": 743,
	"./vca/categories/innovative.png": 743,
	"./vca/categories/intimate": 744,
	"./vca/categories/intimate.png": 744,
	"./vca/categories/popular": 745,
	"./vca/categories/popular.png": 745,
	"./vca/categories/resilient": 746,
	"./vca/categories/resilient.png": 746,
	"./vca/categories/restaurant": 747,
	"./vca/categories/restaurant.png": 747,
	"./vca/categories/risingstar": 748,
	"./vca/categories/risingstar.png": 748,
	"./vca/categories/yacht": 749,
	"./vca/categories/yacht.png": 749,
	"./vca/congrats": 750,
	"./vca/congrats.png": 750,
	"./vca/facebook": 751,
	"./vca/facebook.png": 751,
	"./vca/nome0": 752,
	"./vca/nome0.png": 752,
	"./vca/nome1": 753,
	"./vca/nome1.png": 753,
	"./vca/nome2": 754,
	"./vca/nome2.png": 754,
	"./vca/nome3": 755,
	"./vca/nome3.png": 755,
	"./vca/nome4": 756,
	"./vca/nome4.png": 756,
	"./vca/nome5": 757,
	"./vca/nome5.png": 757,
	"./vca/nomf0": 758,
	"./vca/nomf0.png": 758,
	"./vca/nomf1": 759,
	"./vca/nomf1.png": 759,
	"./vca/nomf2": 760,
	"./vca/nomf2.png": 760,
	"./vca/nomf3": 761,
	"./vca/nomf3.png": 761,
	"./vca/nomf4": 762,
	"./vca/nomf4.png": 762,
	"./vca/nomf5": 763,
	"./vca/nomf5.png": 763,
	"./vca/nomg0": 764,
	"./vca/nomg0.png": 764,
	"./vca/nomg1": 765,
	"./vca/nomg1.png": 765,
	"./vca/nomg2": 766,
	"./vca/nomg2.png": 766,
	"./vca/nomg3": 767,
	"./vca/nomg3.png": 767,
	"./vca/nomg4": 768,
	"./vca/nomg4.png": 768,
	"./vca/nomg5": 769,
	"./vca/nomg5.png": 769,
	"./vca/nomh0": 770,
	"./vca/nomh0.png": 770,
	"./vca/nomh1": 771,
	"./vca/nomh1.png": 771,
	"./vca/nomh2": 772,
	"./vca/nomh2.png": 772,
	"./vca/nomh3": 773,
	"./vca/nomh3.png": 773,
	"./vca/nomh4": 774,
	"./vca/nomh4.png": 774,
	"./vca/nomh5": 775,
	"./vca/nomh5.png": 775,
	"./vca/prizes/anjalichocolat": 776,
	"./vca/prizes/anjalichocolat.png": 776,
	"./vca/prizes/beautehub": 777,
	"./vca/prizes/beautehub.png": 777,
	"./vca/prizes/conspicuousscents": 778,
	"./vca/prizes/conspicuousscents.png": 778,
	"./vca/prizes/feast": 779,
	"./vca/prizes/feast.png": 779,
	"./vca/prizes/human": 780,
	"./vca/prizes/human.png": 780,
	"./vca/prizes/ifly": 781,
	"./vca/prizes/ifly.png": 781,
	"./vca/prizes/motionartspace": 782,
	"./vca/prizes/motionartspace.png": 782,
	"./vca/prizes/onthelist": 783,
	"./vca/prizes/onthelist.png": 783,
	"./vca/prizes/tbakery": 784,
	"./vca/prizes/tbakery.png": 784,
	"./vca/prizes/vrworld": 785,
	"./vca/prizes/vrworld.png": 785,
	"./vca/sponsors/anjalichocolat": 786,
	"./vca/sponsors/anjalichocolat.png": 786,
	"./vca/sponsors/beautehub": 787,
	"./vca/sponsors/beautehub.png": 787,
	"./vca/sponsors/beautenails": 788,
	"./vca/sponsors/beautenails.png": 788,
	"./vca/sponsors/bhmedicalaeshtetics": 789,
	"./vca/sponsors/bhmedicalaeshtetics.png": 789,
	"./vca/sponsors/conspicuousscents": 790,
	"./vca/sponsors/conspicuousscents.png": 790,
	"./vca/sponsors/feast": 791,
	"./vca/sponsors/feast.png": 791,
	"./vca/sponsors/human": 792,
	"./vca/sponsors/human.png": 792,
	"./vca/sponsors/ifly": 793,
	"./vca/sponsors/ifly.png": 793,
	"./vca/sponsors/motionartspace": 794,
	"./vca/sponsors/motionartspace.png": 794,
	"./vca/sponsors/onthelist": 795,
	"./vca/sponsors/onthelist.png": 795,
	"./vca/sponsors/tbakery": 796,
	"./vca/sponsors/tbakery.png": 796,
	"./vca/sponsors/vrworld": 797,
	"./vca/sponsors/vrworld.png": 797,
	"./vca/step1": 798,
	"./vca/step1.png": 798,
	"./vca/step2": 799,
	"./vca/step2.png": 799,
	"./vca/step3": 800,
	"./vca/step3.png": 800,
	"./vca/step4": 801,
	"./vca/step4.png": 801,
	"./vca/trophy": 802,
	"./vca/trophy.png": 802,
	"./vca/vca": 803,
	"./vca/vca-2022": 804,
	"./vca/vca-2022.png": 804,
	"./vca/vca.png": 803,
	"./vca/venuewinner": 805,
	"./vca/venuewinner.png": 805,
	"./vca/whatsapp": 806,
	"./vca/whatsapp.png": 806,
	"./vca/winner1": 807,
	"./vca/winner1.png": 807,
	"./vca/winner2": 808,
	"./vca/winner2.png": 808,
	"./vca/winner3": 809,
	"./vca/winner3.png": 809,
	"./vca/winner4": 810,
	"./vca/winner4.png": 810,
	"./venue-icon": 811,
	"./venue-icon.png": 811,
	"./venue_sample": 812,
	"./venue_sample.png": 812,
	"./video-icon": 813,
	"./video-icon.png": 813,
	"./wedding_success/broadcast": 814,
	"./wedding_success/broadcast.png": 814,
	"./wedding_success/crew": 815,
	"./wedding_success/crew.png": 815,
	"./wedding_success/devices": 816,
	"./wedding_success/devices.png": 816,
	"./wedding_success/room": 817,
	"./wedding_success/room.png": 817,
	"./wedding_success/tvw_logo": 818,
	"./wedding_success/tvw_logo.png": 818,
	"./why-vendor/01": 819,
	"./why-vendor/01.png": 819,
	"./why-vendor/02": 820,
	"./why-vendor/02.png": 820,
	"./why-vendor/03": 821,
	"./why-vendor/03.png": 821,
	"./why-vendor/banner-main": 822,
	"./why-vendor/banner-main.png": 822,
	"./why-vendor/notfound": 823,
	"./why-vendor/notfound.png": 823,
	"./why-vendor/user": 824,
	"./why-vendor/user.svg": 824,
	"./why-vendor/venue": 825,
	"./why-vendor/venue.svg": 825,
	"./why/banner-demo": 826,
	"./why/banner-demo.jpg": 826,
	"./why/banner-main": 827,
	"./why/banner-main.jpg": 827,
	"./why/bg-testi": 828,
	"./why/bg-testi.png": 828,
	"./why/calendar": 829,
	"./why/calendar.png": 829,
	"./why/client1": 830,
	"./why/client1.png": 830,
	"./why/client2": 831,
	"./why/client2.png": 831,
	"./why/crm": 832,
	"./why/crm.png": 832,
	"./why/curated": 833,
	"./why/curated.png": 833,
	"./why/endtoend": 834,
	"./why/endtoend.png": 834,
	"./why/manage": 835,
	"./why/manage.png": 835,
	"./why/payment": 836,
	"./why/payment.png": 836,
	"./why/reporting": 837,
	"./why/reporting.png": 837,
	"./why/room": 838,
	"./why/room.png": 838,
	"./why/setmeeting": 839,
	"./why/setmeeting.png": 839,
	"./why/smartvenue": 840,
	"./why/smartvenue.png": 840,
	"./why/venue": 841,
	"./why/venue.png": 841
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 890;